import React from "react";
import { Alert, Box, Stack, Typography } from "@mui/material";
import { useAuth } from "../../contexts/AuthContext";
import AdminUsersSection from "./AdminUsersSection";
import AdminWeddingsSection from "./AdminWeddingsSection";
import AdminTemplatesSection from "./AdminTemplatesSection";
import AdminUserLookupSection from "./AdminUserLookupSection";
import AdminSponsoredCampaignsSection from "./AdminSponsoredCampaignsSection";
import "../Invitations/Invitations.css";
import "./AdminDashboard.css";

function AdminDashboard() {
  const { authPayload } = useAuth();

  if (authPayload?.role !== "admin") {
    return (
      <Box className="invitation-page-container">
        <Alert severity="error">
          Немате дозвола за пристап до Админ Панел.
        </Alert>
      </Box>
    );
  }

  return (
    <Box className="invitation-page-container admin-page-container">
      <Stack spacing={2} className="invitation-header" alignItems="center">
        <Typography variant="h4" component="h1">
          Админ Панел
        </Typography>
        <Typography variant="body1" color="text.secondary" textAlign="center">
          Управување со корисници и дизајн на покани.
        </Typography>
      </Stack>

      <Stack spacing={2.5} className="admin-sections-wrap">
        <AdminUserLookupSection />
        <AdminUsersSection />
        <AdminWeddingsSection />
        <AdminTemplatesSection />
        <AdminSponsoredCampaignsSection />
      </Stack>
    </Box>
  );
}

export default AdminDashboard;
